// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1778":"71ce5f9c01ea5a62","4871":"36e247bdff03d065","8208":"d90a0cbf6b584d12"}[chunkId] + ".js";
};